<template>
    <div :class="componentClass">
        <slot />
    </div>
</template>

<script setup lang="ts">
    import { computed } from 'vue';
    import useWidgetAppearance from '@/composables/useWidgetAppearance';

    const { positionForIcon, typeForWidget } = useWidgetAppearance();

    const componentClass = computed(() => {
        return [
            'widget-position-layout',
            `widget-position-layout--${positionForIcon.value}`,
            `widget-position-layout--${typeForWidget.value}`,
        ];
    });
</script>

<style scoped lang="scss">
    .widget-position-layout {
        position: fixed;
        user-select: none;
        pointer-events: none;
        display: flex;
        flex-direction: column;
        gap: 1rem;
        inset: 0;

        &--left {
            justify-content: center;
            align-items: start;
        }

        &--right {
            justify-content: center;
            align-items: end;
        }

        &--top {
            justify-content: start;
            align-items: center;
            flex-direction: column-reverse;
        }

        &--top-left {
            justify-content: start;
            align-items: start;
            flex-direction: column-reverse;
        }

        &--top-right {
            justify-content: start;
            align-items: end;
            flex-direction: column-reverse;
        }

        &--bottom {
            justify-content: end;
            align-items: center;
        }

        &--bottom-left {
            justify-content: end;
            align-items: start;

            :deep(.open-button--rectangle) {
                max-height: 48px;
                max-width: 124px;
            }
        }

        &--bottom-right {
            justify-content: end;
            align-items: end;

            :deep(.open-button--rectangle) {
                max-height: 48px;
                max-width: 124px;
            }
        }

        &--icon {
            inset: 1rem;
        }
    }
</style>
